import { IRecipeService } from './IRecipeService';
import { of as observableOf, Observable } from 'rxjs';
import { HttpRequestService } from '../../http-request.service';
import { apiURLs } from '../../../globalcontants';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecipeService implements IRecipeService {
  constructor(private httpService: HttpRequestService) { }

  TestMethod() {
  }
}
